module.exports = __webpack_public_path__ + "img/6_61.7f0f049b.png";